module.exports = __webpack_public_path__ + "static/interoceanica-manutencao-d4199112e2fb5c8ee40e89cc9dbf3787.jpg";